const ParameterTable = ({ parameters = [] }) => {
	if (parameters.length === 0) return null;

	return (
		<div className="mt-2">
			<div className="text-[10px] uppercase text-gray-500 font-semibold mb-1">Parameters</div>
			<div className="border border-border/30 rounded overflow-hidden bg-transparent">
				<table className="w-full text-xs">
					<thead>
						<tr className="bg-accent/30 text-gray-400">
							<th className="text-left px-2 py-1 font-medium">Name</th>
							<th className="text-left px-2 py-1 font-medium">Location</th>
							<th className="text-left px-2 py-1 font-medium">Type</th>
							<th className="text-left px-2 py-1 font-medium">Required</th>
						</tr>
					</thead>
					<tbody>
						{parameters.map((param, i) => (
							<tr key={i} className="border-t border-border/30">
								<td className="px-2 py-1 font-mono text-gray-200">{param.name}</td>
								<td className="px-2 py-1">
									<span className="text-gray-400 lowercase">{param.location}</span>
								</td>
								<td className="px-2 py-1 text-gray-400">{param.type}</td>
								<td className="px-2 py-1">
									{param.required ? (
										<span className="text-red-400 text-[10px]">required</span>
									) : (
										<span className="text-gray-500 text-[10px]">optional</span>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default ParameterTable;
